<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="69"
      viewBox="0 0 62 69"
      fill="none"
    >
      <g clip-path="url(#clip0_1082_4002)">
        <path
          d="M61.5432 5.00125V10.0312C53.2487 16.7901 29.5348 36.1129 24.7243 40.0325C19.3919 35.9496 1.59559 22.324 0 21.1025V5.00125C0 5.00125 11.9442 0 30.7718 0C49.5994 0 61.5436 5.00125 61.5436 5.00125H61.5432Z"
          fill="#44C19A"
        />
        <path
          d="M24.7271 54.4295C25.2406 53.9026 49.9391 28.7976 61.543 16.9988V25.5498C61.543 62.372 30.7712 69.3878 30.7712 69.3878C30.7712 69.3878 1.23769 62.6544 0.0373535 27.7581C7.24186 35.5419 23.81 53.4303 24.7271 54.4295Z"
          fill="#298472"
        />
        <path
          d="M24.7276 54.4294C24.7159 54.4416 24.7163 54.4411 24.7276 54.4294V54.4294Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1082_4002">
          <rect width="62" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
